export default {"src":"/_next/static/media/card7.9b050ed3.svg","height":184,"width":184,"blurWidth":0,"blurHeight":0};